import type { Experiments } from '@wix/yoshi-flow-editor';
import { Challenges } from '../../editor/types/Experiments';
import { isTutorPairReady } from '../storage-contexts/AIChat/isTutorPairReady';
import {
  getScreenOpenBiParams,
  ScreenOpenBiParams,
} from '../../services/biHelpers';
import { IMainProvidersProps } from './IMainProvidersProps';

// Step context for the 600 sent on page load. Only the participant page has
// steps; the Tutor pair is fetched after mount, so its availability is known
// at this point only when the AI chat experiment is off
export const getPageLoadScreenOpenBiParams = (
  props: Pick<
    IMainProvidersProps,
    'participantSteps' | 'selectedStepId' | 'currentChatPair'
  >,
  experiments: Pick<Experiments, 'enabled'>,
): ScreenOpenBiParams => {
  if (!props.participantSteps) {
    return {};
  }

  const step = props.selectedStepId
    ? props.participantSteps.steps?.find(
        ({ id }) => id === props.selectedStepId,
      )
    : undefined;

  return getScreenOpenBiParams({
    step,
    isAiTutorAvailable: getIsAiTutorAvailable(props, experiments),
  });
};

const getIsAiTutorAvailable = (
  props: Pick<IMainProvidersProps, 'currentChatPair'>,
  experiments: Pick<Experiments, 'enabled'>,
) => {
  if (!experiments.enabled(Challenges.enableAiChat)) {
    return false;
  }
  // No pair yet means the request is still in flight: unknown
  return props.currentChatPair
    ? isTutorPairReady(props.currentChatPair)
    : undefined;
};
